<h1 mat-dialog-title>Add Advertiser User</h1>
<div mat-dialog-content>
  <mat-form-field class="example-full-width">
    <mat-label>Filter: Name or Phone</mat-label>
    <input matInput placeholder="Name or Phone" (input)="onChange($event.target['value'])">
  </mat-form-field>

  <div class="table-wrapper">
    <table class="table" mat-table [dataSource]="users$ | async">
      <ng-container matColumnDef="avatar">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <img mat-card-avatar [src]="assertType(element).avatarLowUrl" alt="User Avatar">
        </td>
      </ng-container>
      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef> Roles </th>
        <td mat-cell *matCellDef="let element">
          @if (assertType(element).organizationId && assertType(element).organizationId !== data.organizationId) {
          <mat-icon
            [matTooltip]="'This user is assigned to a differnet organization (' + assertType(element).organizationId + ') and it will be moved to this organization if you select it!'">
            warning
          </mat-icon>
          }
          @if (assertType(element).roles.includes(Roles.owner)) {
          <span>
            <mat-icon>add_business</mat-icon>
          </span>
          }
          @if (assertType(element).roles.includes(Roles.advertiser)) {
          <span>
            <mat-icon>add_shopping_cart</mat-icon>
          </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element"> {{ assertType(element).name }} </td>
      </ng-container>
      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef> Phone </th>
        <td mat-cell *matCellDef="let element"> {{ assertType(element).phoneNumber }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['roles','name','phone']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['roles','name','phone'];" (click)="selectAccount(row)"></tr>
    </table>
    @if (isLoading) {
      <mat-progress-spinner class="auto-center" mode="indeterminate" color="primary" [diameter]="40"></mat-progress-spinner>
    }
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="">Cancel</button>
</div>